import cartModel from "../components/cart/cartModel";

const header = (() => {
    const submenuToggles = ".js-submenuToggle";
    const navToggles = ".js-navToggle";
    const navMenu = ".js-navMenu";
    const backToTopBtn = ".js-backToTop";
    const SELECTOR_CART_QTY = ".js-cartItemCount";
    const searchToggle = ".js-toggleSearch";
    const searchForm = ".js-searchForm";
    const STATE_NAV = "state--nav-open";
    // const SWITCH_MODE_BTN = ".js-switchMode";

    var lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let scrollDirection;

    window.addEventListener('scroll', () => {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      scrollDirection = scrollTop > lastScrollTop ? 'down' : 'up';
      lastScrollTop = Math.max(scrollTop, 0); // For Mobile or negative scrolling

      requestAnimationFrame(() => {
        if(scrollTop > 0) {
          document.body.setAttribute('data-scroll-direction', scrollDirection);
        } else {
          document.body.removeAttribute('data-scroll-direction');
        }
      })
    });

    const updateHeaderQty = function updateCartQuantity(data, id) {
      const elQuantity = document.querySelector(SELECTOR_CART_QTY);
      elQuantity.innerHTML = data.item_count;
    };

    function toggleNav(e) {
      e.preventDefault();
      let menu = document.querySelector(navMenu)
      menu.classList.toggle('active')
      document.body.classList.toggle(STATE_NAV);
    }

    function toggleSearch(e) {
      e.preventDefault();
      let searchDropdown = document.querySelector(searchForm)
      searchDropdown.classList.toggle('active')
    }
    
    function onSubmenuClick(e) {
      e.preventDefault();
      let toggles = document.querySelectorAll(submenuToggles)

      toggles.forEach((el) => {
        if (el == e.currentTarget) {
          el.parentNode.classList.contains('active')
          ? el.parentNode.classList.remove('active')
          : el.parentNode.classList.add('active')
        } else {
          el.parentNode.classList.remove('active')
        }
      })
    }

    function backToTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }

    function switchMode(e) {
      e.preventDefault();
      localStorage.setItem('mode', 
        (localStorage.getItem('mode') || 'dark') === 'dark' ? 'light' : 'dark'); 
        if (localStorage.getItem('mode') === 'dark') {
          document.querySelector('body').classList.add('dark')
          document.querySelector('#mode').innerHTML = "LIGHT"
        } else {
          document.querySelector('body').classList.remove('dark')
          document.querySelector('#mode').innerHTML = "DARK"
        }
    }

    const init = function initHeader() {
      const elNavToggles = document.querySelectorAll(navToggles)
      Array.prototype.forEach.call(elNavToggles, (el) => {
        el.removeEventListener("click", toggleNav);
        el.addEventListener("click", toggleNav);
      })

      const elSearchToggles = document.querySelectorAll(searchToggle)
      Array.prototype.forEach.call(elSearchToggles, (el) => {
        el.removeEventListener("click", toggleSearch);
        el.addEventListener("click", toggleSearch);
      })
      
      const elSubmenuToggles = document.querySelectorAll(submenuToggles)
      Array.prototype.forEach.call(elSubmenuToggles, (el) => {
        el.removeEventListener("click", onSubmenuClick);
        el.addEventListener("click", onSubmenuClick);
      })

      const elBackToTopBtn = document.querySelector(backToTopBtn)
      elBackToTopBtn.addEventListener("click", backToTop);

      cartModel.addCallback(updateHeaderQty);

      // const elSwitchMode = document.querySelector(SWITCH_MODE_BTN)
      // elSwitchMode.addEventListener("click", switchMode);
    };
  
    return {
      init
    };
  })();
  
  export default header;